import React, { useEffect, useState } from 'react';
import {
    Grid,
    Typography,
    Box,
    Button,
    Stack
} from '@mui/material';
import Header from '../components/global/Header';
import WrapperSection from '../components/global/WrapperSection';
import { Document, Page, pdfjs } from 'react-pdf';
import pdf1 from './../assets/documents/financial-2022.pdf'
import pdf2 from './../assets/documents/financial-2023.pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Documents = () => {
    // const years = Array.from({ length: 2 }, (_, i) => 2022 + i);
    const [pageData, setPageData] = useState({});
    const [containerWidth, setContainerWidth] = useState(800);

    const handleDocumentLoadSuccess = (year, { numPages }) => {
        setPageData(prev => ({
            ...prev,
            [year]: {
                numPages: numPages,
                pageNumber: 1
            }
        }));
    };

    const handlePageChange = (year, delta) => {
        setPageData(prev => {
            const currentData = prev[year] || { pageNumber: 1, numPages: null };
            const newPageNumber = currentData.pageNumber + delta;

            if (newPageNumber < 1 || newPageNumber > currentData.numPages) return prev;

            return {
                ...prev,
                [year]: {
                    ...currentData,
                    pageNumber: newPageNumber
                }
            };
        });
    };

    // حساب العرض المتجاوب لكل حاوية
    useEffect(() => {
        const updateWidth = () => {
            const containers = document.querySelectorAll('.pdf-container');
            containers.forEach(container => {
                const newWidth = container.offsetWidth;
                setContainerWidth(Math.min(newWidth, 1200));
            });
        };

        window.addEventListener('resize', updateWidth);
        updateWidth();

        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    return (
        <>
            <Header page={'وثائق مهمة'} />
            <Box sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6} className='pdf-container'>
                        <WrapperSection title={`الوثائق المالية لعام ${2023}`}>
                            <Box
                                sx={{
                                    bgcolor: 'background.paper',
                                    p: 3,
                                    borderRadius: 2,
                                    boxShadow: 3,
                                    overflow: 'hidden',
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                    <Button
                                        component="a"
                                        href={pdf2}
                                        download={pdf2}
                                        variant="contained"
                                        color="primary"
                                    >
                                        تحميل الوثيقة
                                    </Button>
                                </Box>

                                <Document
                                    file={pdf2}
                                    onLoadSuccess={(pdf) => handleDocumentLoadSuccess(2023, pdf)}
                                >
                                    <Page
                                        pageNumber={pageData[2023]?.pageNumber || 1}
                                        width={containerWidth}
                                        height={containerWidth * 1.4142}
                                        sx={{
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            margin: '0 auto',
                                            '& .react-pdf__Page__canvas': {
                                                width: '100% !important',
                                                height: 'auto !important',
                                                margin: '0 auto',
                                            },
                                            '& .react-pdf__Page__textContent': {
                                                display: 'none !important'
                                            },
                                            '& .react-pdf__Page__annotations': {
                                                display: 'none !important'
                                            },
                                        }}
                                    />
                                </Document>

                                <Stack
                                    direction="row"
                                    spacing={2}
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{ mt: 3 }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={() => handlePageChange(2023, -1)}
                                        disabled={(pageData[2023]?.pageNumber || 1) <= 1}
                                    >
                                        السابق
                                    </Button>

                                    <Typography variant="body1" color="text.secondary">
                                        صفحة {pageData[2023]?.pageNumber || 1} من {pageData[2023]?.numPages || '...'}
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        onClick={() => handlePageChange(2023, 1)}
                                        disabled={(pageData[2023]?.pageNumber || 1) >= (pageData[2023]?.numPages || Infinity)}
                                    >
                                        التالي
                                    </Button>
                                </Stack>
                            </Box>
                        </WrapperSection>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className='pdf-container'>
                        <WrapperSection title={`الوثائق المالية لعام ${2022}`}>
                            <Box
                                sx={{
                                    bgcolor: 'background.paper',
                                    p: 3,
                                    borderRadius: 2,
                                    boxShadow: 3,
                                    overflow: 'hidden',
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                    <Button
                                        component="a"
                                        href={pdf1}
                                        download={pdf1}
                                        variant="contained"
                                        color="primary"
                                    >
                                        تحميل الوثيقة
                                    </Button>
                                </Box>

                                <Document
                                    file={pdf1}
                                    onLoadSuccess={(pdf) => handleDocumentLoadSuccess(2022, pdf)}
                                >
                                    <Page
                                        pageNumber={pageData[2022]?.pageNumber || 1}
                                        width={containerWidth}
                                        height={containerWidth * 1.4142}
                                        sx={{
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            margin: '0 auto',
                                            '& .react-pdf__Page__canvas': {
                                                width: '100% !important',
                                                height: 'auto !important',
                                                margin: '0 auto',
                                            },
                                            '& .react-pdf__Page__textContent': {
                                                display: 'none !important'
                                            },
                                            '& .react-pdf__Page__annotations': {
                                                display: 'none !important'
                                            },
                                        }}
                                    />
                                </Document>

                                <Stack
                                    direction="row"
                                    spacing={2}
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{ mt: 3 }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={() => handlePageChange(2022, -1)}
                                        disabled={(pageData[2022]?.pageNumber || 1) <= 1}
                                    >
                                        السابق
                                    </Button>

                                    <Typography variant="body1" color="text.secondary">
                                        صفحة {pageData[2022]?.pageNumber || 1} من {pageData[2022]?.numPages || '...'}
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        onClick={() => handlePageChange(2022, 1)}
                                        disabled={(pageData[2022]?.pageNumber || 1) >= (pageData[2022]?.numPages || Infinity)}
                                    >
                                        التالي
                                    </Button>
                                </Stack>
                            </Box>
                        </WrapperSection>
                    </Grid>

                </Grid>
            </Box>
        </>
    );
};

export default Documents;